enum TableColumnDataType {
  Number = "Number",
  Date = "Date",
  Boolean = "Boolean",
  String = "String",
}

export default TableColumnDataType;
